class CountrySelector extends HTMLElement {
  constructor() {
    super();
    this.select;
    this.flag;
  }
  connectedCallback() {
    this.cacheDomElements();
    this.setEventListeners();
  }
  cacheDomElements() {
    this.select = this.querySelector(
      '[js-country-selector="select"]'
    );
    this.flag = this.querySelector(
      '[js-country-selector="flag"]'
    );
  }
  setEventListeners() {
    if (this.select) {
      this.select.addEventListener("change", (event) => {
        this.updateFlag(event);
        this.handleRedirect(event);
      });
    }
  }
  updateFlag(event) {
    if (!this.flag) {
      return;
    }
    const target = event.target;
    const selectedOption = target.value;
    const flagUrl = `https://cdn.kcak11.com/CountryFlags/countries/${selectedOption}.svg`;
    this.flag.src = flagUrl;
  }
  handleRedirect(event) {
    const target = event.target;
    const selectedOption = target.value;
    const redirectMapping = {
      gb: "brewdog-global.myshopify.com",
      fr: "fr.brewdog.com",
      us: "usa.brewdog.com",
      au: "au.brewdog.com",
      nl: "nl.brewdog.com",
      es: "es.brewdog.com",
      de: "de.brewdog.com"
    };
    const url = redirectMapping[selectedOption];
    if (url) {
      window.location.href = `https://${url}`;
    } else {
      console.warn("No URL found for selected value:", selectedOption);
    }
  }
}
customElements.define("uwp-country-selector", CountrySelector);
